module.exports = __webpack_public_path__ + "img/Fukka-FukaSeat_ItalianRed.d2ea879a.png";